import { Link } from "react-router-dom";
import CaterIndustry from "../../Sections/CaterIndustry";
import FirstTime from "../../Sections/FirstTime";
import HowItWorks from "../../Sections/HowItWorks";
import BottomNav from "../../Layout/BottomNav";
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from "react-compare-slider";
import ImpactSection from "../../Sections/Impactsection";
import SlickSlider from "../../Slider/SlickSlider";
import { Helmet } from "react-helmet";
import ConvertedPrice from "../ConvertedPrice";
// import './day.css'

const PEObjectRemoval = () => {
  const impactSectionData = [
    {
      frontImage: "What_impact_it_will_create_After_1_Web_1749849991.webp",
      backImage: "What_impact_it_will_create_Before_1_Web_1749849992.webp",
      icon: "paint.svg",
      title: "Clutter - Free View",
      desc: "Helps in Listing with clean, unobstructed visuals, increase buyer engagement by 20%",
    },
    {
      frontImage: "What_impact_it_will_create_After_2_Web_1749849991.webp",
      backImage: "What_impact_it_will_create_Before_2_Web_1749849992.webp",
      icon: "castperson.svg",
      title: "Room Appear Larger",
      desc: "Helps in space looks more expensive, perceive property value increased by 25%",
    },
    {
      frontImage: "What_impact_it_will_create_After_3_Web_1749849991.webp",
      backImage: "What_impact_it_will_create_Before_3_Web_1749849992.webp",
      icon: "meteor.svg",
      title: "Highlight Property's Strength",
      desc: "Helps removing distraction, makes unique architectural details to shine.",
    },
  ];

  return (
    <>
      {/* <div className="page_banner">
                <div className="page-title" data-aos="fade-up">
                    <h2>Object/Item Removal</h2>
                    <p>Object removal service in real estate photography seamlessly erases unwanted elements, enhancing property images for a pristine presentation.</p>
                </div>
            </div> */}

      <></>

      {/* <div className="banner-content">
        <h1 data-aos="fade-up">
          Unlock the Power of Virtual Staging in Real Estate!
        </h1>
        <div className="banner-content-links">
          <Link
            className="theme-btn"
            to="/virtual-staging"
          >
            Explore Services
          </Link>
          <Link to="/try-for-free">Or, book a free trial</Link>
        </div>
      </div> */}

      <Helmet>
        <title>
          Erase Objects from Photos in $8 get Flawless Results | Stagobox
        </title>
        <meta
          name="description"
          content="Erase distractions from property photos for $8! Remove objects, Furniture in 24hrs. Get listing-ready images that sell homes 30% faster. Stagobox guaranteed"
        />
      </Helmet>
      <BottomNav />

      <div className="blur-background-box">
        <div className="hp-container">
          <div className="page-title pt-5 pb-5 mb-5" data-aos="fade-up">
            <h1>Object Removal</h1>
            <p>
              <b>
                Elevate your photos with our Object Removal Service, dedicated
                to enhancing the visual appeal of your images.
              </b>
            </p>

            <p>
              By seamlessly removing unwanted objects. We specialize in
              transforming photos by eliminating distractions and enhancing
              their aesthetic quality, ensuring a clean and professional look.
              Discover the power of clear, clutter-free images that highlight
              your subject without distractions. Our meticulous editing process
              ensures that every removed object seamlessly integrates into the
              background, maintaining the natural flow and integrity of the
              scene.
            </p>
          </div>

          <div className="detailed-box mt-5">
            <div className="detail-service-card">
              <div className="detailed-text" data-aos="fade-up">
                <h3>Object/Item Removal</h3>
                <ul className="mt-4">
                  <li>Quick Turnaround Time of 24-48 Hours</li>
                  <li>Super Rapid Delivery in just 12 hours</li>
                  <li>Enjoy unlimited Free Revisions</li>
                  <li>Improve marketability</li>
                  <li>100% Customization Guaranteed</li>
                  <li>Experience Professional Excellence</li>
                </ul>
                <div className="price-per-photo">
                  <h3>
                    <ConvertedPrice price={8} />
                  </h3>
                  <span>Per Photo</span>
                </div>
                <Link
                  to="/services/object-removal-form?key=PE_Object_Removal"
                  className="theme-btn w-100 mt-3"
                  data-aos="fade-up"
                >
                  Place an Order
                </Link>
              </div>
              {/* <div className="detailed-image" data-aos="fade-up"> */}
              <div style={{ width: "50%", height: "100%" }}>
                {/* <Carousel
                  autoplay
                  autoplaySpeed={3000}
                  arrows
                  nextArrow={<ArrowRightOutlined />}
                  prevArrow={<ArrowLeftOutlined />}
                  className="client-rating-slider"
                >
                  

                  

                 
                </Carousel> */}
                <SlickSlider
                  data={[
                    <div key={1}>
                      <div className="compare">
                        <ReactCompareSlider
                          // changePositionOnHover
                          key={2}
                          itemOne={
                            <ReactCompareSliderImage
                              style={{ minHeight: "380px" }}
                              src={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Object_Removal_Before_3_Web_1749849991.webp`}
                            />
                          }
                          itemTwo={
                            <ReactCompareSliderImage
                              src={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Object_Removal_After_3_Web_1749849991.webp`}
                            />
                          }
                        />
                        <div className="beforeafter-tag">
                          <span>Before</span>
                          <span>After</span>
                        </div>
                      </div>
                    </div>,
                    <div key={2}>
                      <div className="compare">
                        <ReactCompareSlider
                          // changePositionOnHover
                          key={2}
                          itemOne={
                            <ReactCompareSliderImage
                              style={{ minHeight: "380px" }}
                              src={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Object_Removal_Before_1_Web_1749849991.webp`}
                            />
                          }
                          itemTwo={
                            <ReactCompareSliderImage
                              src={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Object_Removal_After_1_Web_1749849991.webp`}
                            />
                          }
                        />
                        <div className="beforeafter-tag">
                          <span>Before</span>
                          <span>After</span>
                        </div>
                      </div>
                    </div>,
                    <div key={0}>
                      <div className="compare">
                        <ReactCompareSlider
                          // changePositionOnHover
                          key={0}
                          itemOne={
                            <ReactCompareSliderImage
                              style={{ minHeight: "380px" }}
                              src={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Object_Removal_Before_2_Web_1749849991.webp`}
                            />
                          }
                          itemTwo={
                            <ReactCompareSliderImage
                              src={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Object_Removal_After_2_Web_1749849991.webp`}
                            />
                          }
                        />
                        <div className="beforeafter-tag">
                          <span>Before</span>
                          <span>After</span>
                        </div>
                      </div>
                    </div>,
                  ]}
                />
              </div>
            </div>
          </div>

          {/* <section>
          <div className="floor-plan-cards" data-aos="fade-up">
            {serviceCardsData.map((card, index) => (
              <ServiceCard
                image="/assets/images/industry4.jpg"
                key={index} // Provide a unique key for each card
                title={card.title}
                listItems={card.listItems}
                description={card.description}
                price={card.price}
              />
            ))}
          </div>
        </section> */}
        </div>
        <ImpactSection impactData={impactSectionData} />

        {/* ========== How it works ========== */}
        <HowItWorks redirectionLink="/services/object-removal-form?key=PE_Object_Removal" />
        <div className="hp-container">
          {/* First time */}
          <div data-aos="fade-up">
            <FirstTime />
          </div>

          {/* Design and offer */}
          {/* <DesignWeOfffer /> */}

          {/* Industry we are catering */}
          <div data-aos="fade-up">
            <CaterIndustry />
          </div>

          {/* How we are different from others */}
          {/* <div data-aos="fade-up">
            <IDiff />
          </div> */}
        </div>
      </div>
    </>
  );
};

export default PEObjectRemoval;
